import {axiosInstance} from '../helper/appclient'
import get from 'lodash/get'
import {CHANGE_PASSWORD_URL, FIRST_TIME_CHANGE_PASSWORD_URL, LOGIN_URL} from '../config/url-config'

import {
    ERR_MSG,
    SESS_EXPIRED_TEXT,
    SUCCESS_CODES,
    CHANGE_PASSWORD_105,
    CHANGE_PASSWORD_101,
    CHANGE_PASSWORD_103,
    CHANGE_PASSWORD_104,
    CHANGE_PASSWORD_102,
    CHANGE_PASSWORD_107,
    CHG_PWD_POLICY_ERR,
    CHANGE_PASSWORD_106,
    CURR_PASS_ERR,
    LOGIN_ATTEMPT_ERR
} from "../constants/constants";
import {store} from "../store/store";
import {loadSessionExpired} from "../store/action";
import {extractStatusCode} from "../helper/responsehelper";


export const changePasswordStatus = {
    [CHANGE_PASSWORD_101]:ERR_MSG,
    [CHANGE_PASSWORD_102]:CURR_PASS_ERR,
    [CHANGE_PASSWORD_103]: ERR_MSG,
    [CHANGE_PASSWORD_104]: ERR_MSG,
    [CHANGE_PASSWORD_105]:ERR_MSG,
    [CHANGE_PASSWORD_106]:CHG_PWD_POLICY_ERR,
    [CHANGE_PASSWORD_107]:LOGIN_ATTEMPT_ERR,
    "UNK-ERR-102": ERR_MSG,
};
const constructChangePassword = (formFields)=>(
    {
        currentPassword:get(formFields,"currentPassword"),
        newPassword:get(formFields,"newPassword"),
    }
)
export const changePasswordService = (formFields)=>{
    const changePasswordRequest = constructChangePassword(formFields)

    return new Promise((resolve,reject)=>{
        axiosInstance
            .post(CHANGE_PASSWORD_URL(),changePasswordRequest)
            .then((response) => {
                let statusCode = extractStatusCode(response)
                console.log("change statusCode",statusCode)
                if(SUCCESS_CODES.CHANGE_PASSWORD.includes(statusCode)){
                    resolve(response)
                }else{
                    let errText = changePasswordStatus[statusCode]
                    if(errText === SESS_EXPIRED_TEXT){
                        store.dispatch(loadSessionExpired(true))
                    }
                    reject(errText || ERR_MSG )
                }
            })
            .catch((error) => {
                console.log(error)
                reject(ERR_MSG)
            });
    })
}